export enum SecondaryMarketType {
  WITHDRAWAL_MARKET = 'WITHDRAWAL_MARKET',
  TRANSFER_MARKET = 'TRANSFER_MARKET',
}
